import { plainToClass } from 'class-transformer';

export class Resume {
    profile!: ResumeProfile
    contact!: ResumeContact
    education!: ResumeEducation[]
    experience!: ResumeExperience[]
    skills!: Skills
}

export class ResumeProfile {
    picture!: string
    name!: string
    position!: string
    description!: string 
}

export class ResumeContact {
    email!: string
    phone!: string
    www!: string
}

export class Skills {
    type!: string
    primary!: string[]
    secondary!: string[]

    get hash(): string {
        return JSON.stringify(this)
    }
}

export class ResumeEducation {
    title!: string
    location!: string
    period!: string

    get hash(): string {
        return JSON.stringify(this)
    }
}

export class ResumeExperience {
    name!: string
    type!: string
    location!: string
    website!: string
    description!: string
    positions!: ResumeExperiencePosition[]

    get hash(): string {
        return JSON.stringify(this)
    }
}

export class ResumeExperiencePosition {
    name!: string
    start!: string
    end!: string
    length!: string
    responsibilities!: string[]
    software!: ResumeExperiencePositionSoftware[]

    get hash(): string {
        return JSON.stringify(this)
    }
}

export class ResumeExperiencePositionSoftware {
    icon!: string
    url!: Nullable<string>
    name!: string
    owner!: string
    description!: string
    role!: string
    awards!: ResumeExperiencePositionSoftwareAward[]

    // TODO: Replace with protocol (Hashable)
    get hash(): string {
        return JSON.stringify(this)
    }
}

export class ResumeExperiencePositionSoftwareAward {
    name!: string
    url!: Nullable<string>

    // TODO: Replace with protocol (Hashable)
    get hash(): string {
        return JSON.stringify(this)
    }
}